.root {
  font-weight: 400;
  text-transform: uppercase;

  &:not([data-disabled="true"]) {
    &:active {
      /** TODO: use `variantColorResolver` function in theme.ts -- https://mantine.dev/styles/variants-sizes/#variantcolorresolver */
      outline: var(--mantine-spacing-xs) solid var(--mantine-color-primary-light);
    }

    &[data-variant="light"],
    &[data-variant="subtle"],
    &[data-variant="transparent"] {
      &:active {
        outline: var(--mantine-spacing-xxs) solid var(--ai-color);
        outline-offset: var(--mantine-spacing-xxs);
      }
    }

    &[data-variant="danger"] {
      background-color: inherit;
      color: var(--mantine-color-red-6);

      &:hover {
        background-color: var(--mantine-color-red-1);
      }
    }
  }

  &[data-variant="light"] {
    background-color: light-dark(var(--ai-bg), var(--mantine-color-primaryDark-7));

    &:hover {
      background-color: light-dark(var(--mantine-color-primary-1), var(--mantine-color-dark-5));
    }
  }

  &[data-variant="whiteWithHover"] {
    border-color: var(--mantine-spacing-xxs) solid var(--mantine-color-primary-7);
    background-color: white;
    color: light-dark(var(--mantine-color-primary-6), var(--mantine-color-primaryDark-7));

    &:hover {
      background-color: light-dark(var(--mantine-color-primary-0), var(--mantine-color-dark-5));
    }
  }
}
